import { PlaceOfServiceContainer } from '../../features/master-data/place-of-service/PlaceOfServiceContainer';
import {
  compose,
  withAuthorized,
  withBaseLayout,
  withHelmet
} from '../../core';

export const MasterDataPlaceOfService = compose(
  withAuthorized,
  withBaseLayout,
  withHelmet({
    title: 'Splashworks: Places of Service'
  })
)(PlaceOfServiceContainer);
